import { Card, Col, Progress, Row, Tag } from "antd";
import { StarFilled } from "@ant-design/icons";
import MathUtils from "../../../../common/utils/MathUtils";
import reviewsIcon from '../../../../assets/icons/REVIEWS-ICON-light.png';
const cardBody = {
    backgroundColor: 'white',
    borderRadius: '16px',
    height: 88,
    padding: '10px 14px',
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'center',
};

const kpiLabel = {
    fontSize: 11,
    color: '#9F9F9F',
    fontWeight: 500,
    lineHeight: 1.2,
    marginTop: 2,
};

const CompactRecentKpi = (props: { reviewsKPIs: any, recentPeriod: string }) => (
    <Card bodyStyle={{ ...cardBody, color: 'steelblue' }} style={{ border: 'none' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 2 }}>
            <Tag style={{
                borderRadius: 10,
                margin: 0,
                fontSize: 11,
                lineHeight: '18px',
                padding: '0 8px',
                color: '#64748b',
                background: '#f1f5f9',
                border: '1px solid #e2e8f0',
            }}>
                {PERIOD[props.recentPeriod]}
            </Tag>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span style={{ fontSize: 28, fontWeight: 700, lineHeight: 1, color: 'steelblue' }}>
                    {props.reviewsKPIs.numberOfRecentReviews > 0
                        ? <><StarFilled style={{ fontSize: 20, paddingRight: 6, color: 'LightSteelBlue' }}/>{MathUtils.round(props.reviewsKPIs.recentRateAvg, 1)}</>
                        : '-'}
                </span>
                <span style={{ ...kpiLabel, color: 'steelblue' }}>{props.reviewsKPIs?.numberOfRecentReviews} reseñas</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span style={{ fontSize: 28, fontWeight: 700, lineHeight: 1, color: 'steelblue' }}>
                    {props.reviewsKPIs.numberOfRecentReviews > 0
                        ? `${MathUtils.round(100 * props.reviewsKPIs.recentRepliedRatio, 1)}%`
                        : '-'}
                </span>
                <span style={{ ...kpiLabel, color: 'steelblue' }}>% Respuesta</span>
            </div>
        </div>
    </Card>
);

const TallRecentKpi = (props: { reviewsKPIs: any, recentPeriod: string }) => {
    const hasRecent = Number(props.reviewsKPIs?.numberOfRecentReviews) > 0;
    const replyPct = hasRecent
        ? MathUtils.round(100 * props.reviewsKPIs.recentRepliedRatio, 1)
        : null;
    const rate = hasRecent ? MathUtils.round(props.reviewsKPIs.recentRateAvg, 1) : null;

    return (
        <Card
            style={{ border: 'none', height: '100%' }}
            bodyStyle={{
                backgroundColor: 'white',
                borderRadius: 25,
                height: 327,
                padding: '22px 24px',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
                marginBottom: 20,
            }}>
                <h1 style={{ margin: 0, color: '#9F9F9F', fontSize: 13, fontWeight: 600 }}>
                    Periodo reciente
                </h1>
                <Tag style={{
                    borderRadius: 10,
                    margin: 0,
                    fontSize: 11,
                    lineHeight: '18px',
                    padding: '0 8px',
                    color: '#64748b',
                    background: '#f1f5f9',
                    border: '1px solid #e2e8f0',
                }}>
                    {PERIOD[props.recentPeriod]}
                </Tag>
            </div>

            {!hasRecent ? (
                <div style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    color: '#94a3b8',
                    fontSize: 14,
                    fontWeight: 600,
                    padding: '0 12px',
                }}>
                    No hay reseñas en el periodo reciente
                </div>
            ) : (
                <>
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 8,
                        marginBottom: 20,
                    }}>
                        <Progress
                            type="circle"
                            percent={replyPct ?? 0}
                            width={128}
                            strokeWidth={8}
                            strokeColor="#7b93a8"
                            trailColor="#e2e8f0"
                            format={() => (
                                <span style={{
                                    display: 'inline-flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    lineHeight: 1.15,
                                }}>
                                    <span style={{ fontSize: 28, fontWeight: 700, color: '#475569' }}>
                                        {replyPct == null ? '-' : `${replyPct}%`}
                                    </span>
                                    <span style={{ fontSize: 11, fontWeight: 600, color: '#94a3b8', marginTop: 4 }}>
                                        Respuesta
                                    </span>
                                </span>
                            )}
                        />
                    </div>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: 10,
                    }}>
                        <div style={{
                            background: '#f8fafc',
                            borderRadius: 14,
                            padding: '14px 12px',
                            textAlign: 'center',
                        }}>
                            <div style={{ fontSize: 22, fontWeight: 700, color: '#334155', lineHeight: 1.1 }}>
                                {rate == null
                                    ? '-'
                                    : <>{rate} <StarFilled style={{ fontSize: 14, color: '#7b93a8' }} /></>}
                            </div>
                            <div style={{ ...kpiLabel, marginTop: 6, color: '#94a3b8' }}>Nota media</div>
                        </div>
                        <div style={{
                            background: '#f8fafc',
                            borderRadius: 14,
                            padding: '14px 12px',
                            textAlign: 'center',
                        }}>
                            <div style={{ fontSize: 22, fontWeight: 700, color: '#334155', lineHeight: 1.1 }}>
                                {props.reviewsKPIs?.numberOfRecentReviews ?? 0}
                            </div>
                            <div style={{ ...kpiLabel, marginTop: 6, color: '#94a3b8' }}>Reseñas</div>
                        </div>
                    </div>
                </>
            )}
        </Card>
    );
};

export const BlockReviewsRecentKpi = (props: {
    reviewsKPIs: any,
    recentPeriod: string,
    /** Panel alto alineado con las cards de gráficos (327px). */
    tall?: boolean,
}) => (
    props.tall
        ? <TallRecentKpi reviewsKPIs={props.reviewsKPIs} recentPeriod={props.recentPeriod} />
        : <CompactRecentKpi reviewsKPIs={props.reviewsKPIs} recentPeriod={props.recentPeriod} />
);

export const BlockReviewsKpis = (props: {
    reviewsKPIs: any,
    period: string,
    recentPeriod: string,
    minMax: boolean,
    /** Si false, solo muestra la card principal (p.ej. cuando el % respuesta va en otra columna). */
    showRecent?: boolean,
}) => {
    const showRecent = props.showRecent !== false;

    return (
        <Row gutter={showRecent ? 16 : 36} style={{ marginBottom: 8 }}>
            <Col span={showRecent ? 12 : 24}>
                <Card bodyStyle={cardBody}>
                    {showRecent && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 2 }}>
                            <Tag color='steelblue' style={{ borderRadius: 10, margin: 0, fontSize: 11, lineHeight: '18px', padding: '0 8px' }}>
                                {props.period?.startsWith('CUSTOM') ? <>Rango Personalizado</> : PERIOD[props.period]}
                            </Tag>
                        </div>
                    )}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: showRecent ? 'space-around' : 'center',
                        gap: showRecent ? 8 : 160,
                    }}>
                        {props.minMax && props.reviewsKPIs?.rateMin &&
                            <div style={{ textAlign: 'center', color: '#94a3b8' }}>
                                <div style={{ fontSize: showRecent ? 11 : 13, fontWeight: 500, marginBottom: 2 }}>Mínimo</div>
                                <div style={{ fontSize: showRecent ? 14 : 18, color: '#94a3b8' }}>
                                    <StarFilled style={{ fontSize: showRecent ? 14 : 18, color: '#94a3b8' }} />
                                    <b style={{ color: '#94a3b8', fontWeight: 600 }}> {Number(props.reviewsKPIs.rateMin).toFixed(1)}</b>
                                </div>
                            </div>
                        }
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 4,
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: showRecent ? 10 : 14 }}>
                                <span style={{ fontSize: showRecent ? 28 : 34, fontWeight: 700, lineHeight: 1, color: '#475569' }}>
                                    {props.reviewsKPIs?.rateAvg === null ? '-' : MathUtils.round(props.reviewsKPIs?.rateAvg, 1)}
                                </span>
                                <img src={reviewsIcon} style={{ height: showRecent ? 36 : 40, borderRadius: 12 }}/>
                            </div>
                            <span style={{
                                fontSize: showRecent ? 13 : 15,
                                fontWeight: 700,
                                color: '#64748b',
                                lineHeight: 1.2,
                            }}>
                                {props.reviewsKPIs.numberOfReviews} reseñas
                            </span>
                        </div>
                        {props.minMax && props.reviewsKPIs?.rateMax &&
                            <div style={{ textAlign: 'center', color: '#94a3b8' }}>
                                <div style={{ fontSize: showRecent ? 11 : 13, fontWeight: 500, marginBottom: 2 }}>Máximo</div>
                                <div style={{ fontSize: showRecent ? 14 : 18, color: '#94a3b8' }}>
                                    <StarFilled style={{ fontSize: showRecent ? 14 : 18, color: '#94a3b8' }} />
                                    <b style={{ color: '#94a3b8', fontWeight: 600 }}> {Number(props.reviewsKPIs.rateMax).toFixed(1)}</b>
                                </div>
                            </div>
                        }
                    </div>
                </Card>
            </Col>
            {showRecent && (
                <Col span={12}>
                    <BlockReviewsRecentKpi reviewsKPIs={props.reviewsKPIs} recentPeriod={props.recentPeriod} />
                </Col>
            )}
        </Row>
    );
};

export const PERIOD: any = {
    "ALL": "Desde el Inicio",
    "LAST_7DAYS": "Últimos 7 días",
    "LAST_30DAYS": "Últimos 30 días",
    "CURRENT_MONTH": "Mes Actual",
    "PREVIOUS_MONTH": "Mes Anterior",
    "LAST_3MONTHS": "Últimos 3 meses",
    "LAST_12MONTHS": "Últimos 12 meses"
};
